@if (deactivationDays) {
  <div class="account-deletion-container">
    <div class="account-deletion-header">
      <div [innerHtml]="'home.account-deletion.are-you-sure' | translate"></div>
    </div>
    <br />
    <slotcom-divider></slotcom-divider>
    <br />
    <div [innerHtml]="'home.account-deletion.attention' | translate"></div>
    <br />
    <b><div [innerHtml]="'home.account-deletion.permanent-warning' | translate"></div></b>
    <br />
    <div>
      <span [innerHtml]="'home.account-deletion.blocking-info-1' | translate"></span>
      <b
        ><span>{{ deactivationDays }}</span></b
      >
      <span [innerHtml]="'home.account-deletion.blocking-info-2' | translate"></span>
    </div>
    <br />
    <div>
      <span [innerHtml]="'home.account-deletion.reactivation-info-1' | translate"></span>
      <span>{{ deactivationDays }}</span>
      <span [innerHtml]="'home.account-deletion.reactivation-info-2' | translate"></span>
    </div>
    <br />
    <slotcom-divider></slotcom-divider>
    <br />
    <div class="account-deletion-footer">
      <div>
        <small [innerHtml]="'home.account-deletion.permanent-warning' | translate"></small>
      </div>
      <br />
      <div class="button-container">
        <slotcom-button
          class="c-button--purple left-btn"
          (safeClick)="stepForward()"
          audioType="functionality">
          {{ 'home.buttons.accept' | translate | uppercase }}
        </slotcom-button>
        <slotcom-button
          class="c-button--pink right-btn"
          (safeClick)="closeModal()"
          audioType="functionality">
          {{ 'home.buttons.cancel' | translate | uppercase }}
        </slotcom-button>
      </div>
    </div>
  </div>
}
